import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import Navbar from "../../components/navbar/Navbar";
import Hotpicks from "../../components/hotpicks/hotpicks";
import "./home.css";

// radio button implementation from https://www.geeksforgeeks.org/how-to-implement-radio-button-in-react/

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchItem from "../../components/searchItem/SearchItem";

const baseUrl = process.env.REACT_APP_BASE_URL || "http://127.0.0.1:5000"; // Default to localhost if not provided in environment variables
if (baseUrl.trim() === "http://127.0.0.1:5000") {
  console.log("base URL = ", baseUrl);
}
const Home = () => {
  // Handle radio buttons
  const [selectedRadioValue, setSelectedRadioValue] = useState("rbRecommended");
  // handle radio changes
  const handleRadioChange = (value) => {
    setSelectedRadioValue(value);
  };
  // handle check boxes
  const [allchecked, setAllChecked] = React.useState([]);
  // handle changes to checkboxes
  function handleChange(e) {
    if (e.target.checked) {
      setAllChecked([...allchecked, e.target.value]);
    } else {
      setAllChecked(allchecked.filter((item) => item !== e.target.value));
    }
  }
  if (baseUrl.trim() === "http://127.0.0.1:5000") {
    console.log(selectedRadioValue);
    console.log(allchecked);
  }
  const [searchItems, setSearchItems] = useState([]); //We're using the useState hook to maintain the state of searchItems.
  const [hotPickItems, setHotPickItems] = useState([]); //We're using the useState hook to maintain the state of hotpicks.

  useEffect(() => {
    fetchData(selectedRadioValue, allchecked).then(() => fetchHotPicksData());
  }, []);

  //define function to handle click of event from navbar
  const handleNavBarButtonClick = (buttonName) => {
    switch (buttonName) {
      case "navHotButton":
        // Perform actions when navHotButton is clicked
        fetchData("rbRecommended", ["topPicksOnly"]); // Example: Fetch data for hot competitions
        break;
      case "navAllButton":
        // Perform actions when navAllButton is clicked
        fetchData("rbRecommended", ["showall"]); // Example: Fetch all data
        break;
      case "navFreeButton":
        // Perform actions when navFreeButton is clicked
        fetchData("rbRecommended", ["free"]); // Example: Fetch data for competitions ending soon
        break;
      // Add more cases for other buttons if needed
      default:
        fetchData("rbRecommended", ["showall"]); // Example: Fetch all data
        // Default case
        break;
    }
  };

  const fetchData = (sortBy, filters) => {
    // Convert where (allchecked array) to a comma-separated string
    // Check if where (allchecked array) is defined and not empty before joining
    // const whereString = where && where.length > 0 ? where.join(",") : "";
    if (baseUrl.trim() === "http://127.0.0.1:5000") {
      console.log("-------------filters = ", filters);
    }
    const filterString = filters.length === 0 ? "showAll" : filters.join("&");
    if (baseUrl.trim() === "http://127.0.0.1:5000") {
      console.log("filterString = ", filterString);
      console.log("Sortby = ", sortBy);
      console.log("filterstring = ", filterString);
    }
    return fetch(`${baseUrl}/get/sortedCompetitions/${sortBy}/${filterString}`)
      .then((response) => response.json())
      .then((data) => {
        if (baseUrl.trim() === "http://127.0.0.1:5000") {
          console.log("in .then(data)");
        }
        setSearchItems(data);
      })
      .catch((error) => {
        if (baseUrl.trim() === "http://127.0.0.1:5000") {
          console.error("Error fetching data: ", error);
        }
      });
  };

  const fetchHotPicksData = () => {
    fetch(`${baseUrl}/get/sortedCompetitions/hp4/hp4`)
      .then((response) => response.json())
      .then((data) => {
        setHotPickItems(data);
      })
      .catch((error) => {
        if (baseUrl.trim() === "http://127.0.0.1:5000") {
          console.error("Error HotPicks fetching data: ", error);
        }
      });
  };
  const navigate = useNavigate();

  const handleUpdateSearch = () => {
    // navigate(`/get/sortedCompetitions/${selectedRadioValue}`);
    // Fetch data when the button is clicked
    fetchData(selectedRadioValue, allchecked);
  };

  return (
    <div>
      <Header />
      <Navbar onNavButtonClick={handleNavBarButtonClick} />{" "}
      {/* Pass the handleNavButtonClick function as a prop */}
      <div className="listContainer">
        <div className="listWrapper">
          <div className="listSearch">
            <div className="lsItem">
              <label htmlFor="radioGroup">Sort By</label>
              <div className="radioGroup">
                <div className="radioButton">
                  <input
                    type="radio"
                    id="rbRecommended"
                    value="rbRecommended"
                    checked={selectedRadioValue === "rbRecommended"}
                    onChange={() => handleRadioChange("rbRecommended")}
                  />
                  <label htmlFor="rbRecommended">Recommended</label>
                </div>
                <div className="radioButton">
                  <input
                    type="radio"
                    id="rbCashValue"
                    value="rbCashValue"
                    checked={selectedRadioValue === "rbCashValue"}
                    onChange={() => handleRadioChange("rbCashValue")}
                  />
                  <label htmlFor="rbCashValue">Greatest Cash Value</label>
                </div>
                <div className="radioButton">
                  <input
                    type="radio"
                    id="rbBestOdds"
                    value="rbBestOdds"
                    checked={selectedRadioValue === "rbBestOdds"}
                    onChange={() => handleRadioChange("rbBestOdds")}
                  />
                  <label htmlFor="rbBestOdds">Best Odds</label>
                </div>
                <div className="radioButton">
                  <input
                    type="radio"
                    id="rbEndingSoon"
                    value="rbEndingSoon"
                    checked={selectedRadioValue === "rbEndingSoon"}
                    onChange={() => handleRadioChange("rbEndingSoon")}
                  />
                  <label htmlFor="rbEndingSoon">Competition End date</label>
                </div>
                <div className="radioButton">
                  <input
                    type="radio"
                    id="rbNewestComp"
                    value="rbNewestComp"
                    checked={selectedRadioValue === "rbNewestComp"}
                    onChange={() => handleRadioChange("rbNewestComp")}
                  />
                  <label htmlFor="rbNewestComp">Newest Competition</label>
                </div>
                <div className="radioButton">
                  <input
                    type="radio"
                    id="rbHighestTicketPrice"
                    value="rbHighestTicketPrice"
                    checked={selectedRadioValue === "rbHighestTicketPrice"}
                    onChange={() => handleRadioChange("rbHighestTicketPrice")}
                  />
                  <label htmlFor="rbHighestTicketPrice">
                    Highest Ticket Price
                  </label>
                </div>

                <div className="radioButton">
                  <input
                    type="radio"
                    id="rbLowestTicketPrice"
                    value="rbLowestTicketPrice"
                    checked={selectedRadioValue === "rbLowestTicketPrice"}
                    onChange={() => handleRadioChange("rbLowestTicketPrice")}
                  />
                  <label htmlFor="rbLowestTicketPrice">
                    Lowest Ticket Price
                  </label>
                </div>
              </div>
            </div>
            <div className="lsItem">
              <label htmlFor="checkboxFilterByGroup">Only Show Me</label>
              <div className="checkboxFilterByGroup">
                <div className="checkboxFilter">
                  <input
                    value="topPicksOnly"
                    type="checkbox"
                    onChange={handleChange}
                  />
                  <span> Top Picks Only </span>
                </div>
                <div className="checkboxFilter">
                  <input
                    value="5pcChanceOfWin"
                    type="checkbox"
                    onChange={handleChange}
                  />
                  <span> 5% or More Chance of Win </span>
                </div>
                <div className="checkboxFilter">
                  <input
                    value="min1000CashAlternative"
                    type="checkbox"
                    onChange={handleChange}
                  />
                  <span> Min £1000 Cash Alternative</span>
                </div>

                <div className="comapanyBreakHeader">Companies</div>

                <div className="checkboxFilter">
                  <input
                    value="hotComp"
                    type="checkbox"
                    onChange={handleChange}
                  />
                  <span> HotComp</span>
                </div>
                <div className="checkboxFilter">
                  <input
                    value="revComp"
                    type="checkbox"
                    onChange={handleChange}
                  />
                  <span> RevComp</span>
                </div>
                <div className="checkboxFilter">
                  <input
                    value="jammy"
                    type="checkbox"
                    onChange={handleChange}
                  />
                  <span> Jammy</span>
                </div>
                <div className="checkboxFilter">
                  <input
                    value="croccomps"
                    type="checkbox"
                    onChange={handleChange}
                  />
                  <span> CrocComps</span>
                </div>

                {/* <div>The all checked values are {allchecked.join(" , ")}</div> */}
              </div>
            </div>

            {/* <button>Update Search</button> */}
            <button onClick={handleUpdateSearch}>Update Search</button>
          </div>

          {/* This will dynamically generate SearchItem components based on the data fetched from your JSON file, replacing the static code you had before. Make sure to replace 'your_json_file_path.json' with the actual path to your JSON file */}
          {/* In the return statement, we use searchItems.map() to iterate over each item in the searchItems array. */}
          <div className="listResult">
            {searchItems.map((item, index) => (
              <SearchItem key={index} data={item} />
            ))}
          </div>

          {/* <div className="listResult">
            <SearchItem />
            <SearchItem />
            <SearchItem />
            <SearchItem />
            <SearchItem />
            <SearchItem />
            <SearchItem />
            <SearchItem />
            <SearchItem />
          </div> */}

          <div className="hotPicksContainer">
            <div className="hotPicksTitle">Hottest Picks</div>
            {hotPickItems.map((item, index) => (
              <Hotpicks key={index} data={item} />
            ))}
            {/* <Hotpicks />
            <Hotpicks />
            <Hotpicks />
            <Hotpicks /> */}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
